import React, { Component } from "react";
import { connect } from "react-redux";

// State
import { addRoute } from "../../store/actions/route";
import { setpageTitle } from "../../store/actions/siteInfo";

class AdminLanding extends Component {
	constructor(props) {
		super(props);
		this.props.addRoute(this.props.match);

		this.props.setpageTitle("Admin Area");
	}

	render() {
		return <div>Welcome to the admin area</div>;
	}
}

export default connect(
	null,
	{ addRoute, setpageTitle }
)(AdminLanding);



// WEBPACK FOOTER //
// ./src/components/admin/AdminLanding.js